import { render, staticRenderFns } from "./SurveyRecommendation.vue?vue&type=template&id=2c12860e&scoped=true&"
import script from "./SurveyRecommendation.vue?vue&type=script&lang=js&"
export * from "./SurveyRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./SurveyRecommendation.vue?vue&type=style&index=0&id=2c12860e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c12860e",
  null
  
)

export default component.exports